module.exports = __webpack_public_path__ + "img/AUTO_MEDICAMENT_DESACTIVE.780ebdcd.svg";